var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",class:{ initial: _vm.getLoadState }},[_c('router-link',{attrs:{"to":{ name: 'photo', params: { id: _vm.data.id } }}},[_c('div',{staticClass:"thumbnail"},[_c('img',{staticClass:"img",attrs:{"src":_vm.data.media_details.sizes.medium.source_url + _vm.getAdditionalExt,"loading":"lazy"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }